export interface ClassBuilder {
    class: string[];
    case: boolean;
    excludeOn?: string[];
    modifier?: ClassBuilder[];
}

export interface SelectOption {
    label: string;
    value: string;
    group?: string;
}

export interface SingleDateChange {
    mode: CalendarMode.Single;
    date: string;
}

export interface RangeDateChange {
    mode: CalendarMode.Range;
    start: string;
    end: string;
}

export enum CalendarMode {
    Single = 'single',
    Range = 'range',
}

export enum Sheets {
    Single = 1,
    Double = 2,
}
